import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-furnizorserviciisociale',
  templateUrl: './furnizorserviciisociale.component.html',
  styleUrls: ['./furnizorserviciisociale.component.css']
})
export class FurnizorserviciisocialeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
